import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const PriceSummarySection = ({title, onEdit, products}) => {
    return (
        <div className='price-summary-section'>
            <div className='header'>
                <span className='title'>{title}</span>
                {onEdit && (
                    <button className='edit' onClick={onEdit}>עריכה</button>
                )}
            </div>
            {products?.map((product) => {
                const isExpanded = product?.oneTimeFee && product?.monthlyFee;

                return (
                    <div key={product?.name} className='product-row'>
                        {isExpanded && <p className='product-name'>{product?.name}</p>}
                        <div className='product-details'>
                            {isExpanded ? (
                                <div className='product-expanded'>
                                    <div className='expanded-row'>
                                        <span className='pricing'>סה״כ חיוב חד פעמי</span>
                                        <span className='product-price'>
                                        <span className='ils'>₪</span>
                                            {product?.oneTimeFee}
                                        </span>
                                    </div>
                                    <div className='expanded-row'>
                                        <span className='pricing'>סה״כ חיוב חודשי</span>
                                        <span className='product-price'>
                                        <span className='ils'>₪</span>
                                            {product?.monthlyFee}
                                            <span className='ils'> לחודש</span>
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className='product-name'>
                                        {product?.isAddOn && (
                                            <Image src={require('./images/plus.svg')}
                                                className='plus-icon'
                                                alt='plus-icon' />
                                        )}
                                        <span>{product?.name}</span>
                                    </div>
                                    <span className='product-price'>
                                     {product.price>0 ?<>
                                         {product?.price}
                                        <span className='ils'>  ₪ {product?.monthly && "לחודש"} </span>
                                        </>:
                                        <span className='ils'> ללא עלות</span>
                                      }
                                    </span>

                                </>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PriceSummarySection;
